import {
    putCostProviderLoading,
    putCostProviderRequest,
    putCostProviderSuccess,
    putCostProviderReject,
    putCostProviderReset
} from "../../actions/costProvider/put";

export const putCostProvider = (formData) => async (dispatch, getState) => {
    dispatch(putCostProviderLoading());
    try {
        const { data } = await putCostProviderRequest(formData, getState);
        dispatch(putCostProviderSuccess(data))
    } catch (error) {
        dispatch(putCostProviderReject(error))
    } finally {
        setTimeout(() => { dispatch(putCostProviderReset()) }, 3000);
    }
    return Promise.resolve();
};